'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.onRouteUpdate = onRouteUpdate;
function onRouteUpdate(_ref) {
    var location = _ref.location;

    if (process.env.NODE_ENV === 'production' && (typeof _hsq === 'undefined' ? 'undefined' : _typeof(_hsq)) === 'object') {
        var _hsq2 = window._hsq = window._hsq || [];
        _hsq2.push(['setPath', location ? location.pathname + location.search + location.hash : undefined]);
        _hsq2.push(['trackPageView']);
    }
}